(function() {
 	'use strict';

 	var $accordion 			= $(".base-accordion"),
 			$accordionLabel = $(".base-accordion__label");

 	if ( $accordion.length > 0 ) {

		$accordionLabel.click(function(){
			$(this).toggleClass("is-open");
		});

 	}

})();